import { createStyles } from 'antd-style';

import { ThemeFont, ThemeSpaces } from '../../theme';

export const useProcessingModalStyles = createStyles(({ token }) => ({
  processingModal: {
    '.QuickOnlineLogo': {
      [`@media (min-width: ${token.screenMDMin}px)`]: {
        width: 220,
        height: 64,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 200,
        height: 58,
      },
    },

    '> img': {
      margin: `${ThemeSpaces.SPACE_NORM_20}px 0`,
      [`@media (min-width: ${token.screenMDMin}px)`]: {
        width: 301,
        height: 307,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        width: 260,
        height: 265,
      },
    },

    'h1.ant-typography': {
      color: token.colorText,
      fontWeight: 'bold',
      fontFamily: ThemeFont.FONT_CONDENSED,
      marginBottom: 0,

      [`@media (min-width: ${token.screenMDMin}px)`]: {
        fontSize: 32,
      },
      [`@media (max-width: ${token.screenSMMax}px)`]: {
        fontSize: token.fontSizeHeading2,
      },
    },
  },
}));
